import { PaginationResponse } from "baaanggg";

type Props = {
    pagination: PaginationResponse,
    currentPage: number,
    onPageChange: (page: number) => void
}

export function PaginationBar({ pagination: { page, totalPage }, currentPage, onPageChange }: Props) {
    let startPage, endPage;
    const maxItem = 5;

    if (totalPage <= maxItem) {
        startPage = 1;
        endPage = totalPage;
    } else {
        if (currentPage <= Math.floor(maxItem / 2) + 1) {
            startPage = 1;
            endPage = maxItem;
        } else if (currentPage + Math.floor(maxItem / 2) >= totalPage) {
            startPage = totalPage - maxItem + 1;
            endPage = totalPage;
        } else {
            startPage = currentPage - Math.floor(maxItem / 2);
            endPage = currentPage + Math.floor(maxItem / 2);
        }
    }

    const array = [];
    for (let i = startPage; i <= endPage; i++) {
        array.push(i);
    }

    return <div className="flex flex-wrap justify-center">
        {
            page > 1 && <button
                key={-1}
                onClick={() => onPageChange(1)}
                className={`mx-1 rounded-full w-12 h-12 text-center font-semibold text-white transition-all hover:bg-jacarta-800 bg-jacarta-500`}>
                {"<<"}
            </button>
        }

        {
            array.map((page, index) => {

                if (currentPage === page)
                    return <button key={index} className="rounded-full w-12 h-12 mx-1 bg-white text-center font-semibold text-jacarta-500 shadow-white-volume transition-all">
                        {page}
                    </button>

                return <button
                    key={index}
                    onClick={() => onPageChange(page)}
                    className={`mx-1 rounded-full w-12 h-12 text-center font-semibold text-white transition-all hover:bg-jacarta-800 bg-jacarta-500`}>
                    {page}
                </button>
            })
        }
        {
            page < totalPage && <button
                key={-999}
                onClick={() => onPageChange(totalPage)}
                className={`mx-1 rounded-full w-12 h-12 text-center font-semibold text-white transition-all hover:bg-jacarta-800 bg-jacarta-500`}>
                {">>"}
            </button>
        }
    </div>
}